// components/features/clients/ClientList.tsx

import { Client } from '../../../types/features/Client';
import TableList, { SelectAction } from '../../ui/TableList';
import ClientRow from './ClientRow';

interface ClientListProps {
  clients: Client[];
  onAction: (client: Client) => void;
  onSelectClients?: (selectedClients: Client[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function ClientList({
  clients,
  onAction,
  onSelectClients,
  selectable = false,
  selectActions
}: ClientListProps) {
  const columns = [
    { header: "Client", className: "w-2/5" },
    { header: "Téléphone", className: "hidden sm:table-cell w-1/4" },
    { header: "Inscrit le", className: "hidden md:table-cell w-1/4" },
  ];

  return (
    <TableList
      items={clients}
      columns={columns}
      getId={(client) => client.id}
      onAction={onAction}
      onSelectItems={onSelectClients}
      selectable={selectable}
      emptyMessage="Aucun client trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(client, isSelected, onSelect) => (
        <ClientRow
          key={client.id}
          client={client}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}